// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDoftMMPT5wz8jK0fak1_YgWab8I2cZrEc",
  authDomain: "japan-pmmax.firebaseapp.com",
  projectId: "japan-pmmax",
  storageBucket: "japan-pmmax.firebasestorage.app",
  messagingSenderId: "905029669824",
  appId: "1:905029669824:web:ed74dda7e1de19cf83ee25",
  measurementId: "G-ZRHY0KLLY5",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
